import React from 'react';
export const PrivacyPolicy = React.lazy(() => import('./PrivacyPolicy'));
